// extracted by mini-css-extract-plugin
export var compactFilters = "_e9-4";
export var detailImage = "_e9-1";
export var dropdownContainer = "_e9-2";
export var imageContainer = "_e9-0";
export var selectedCard = "_e9-3";